import { Axios } from "../../../../axios";

export * from "../../base/store/actions";

export function get_options({ commit, rootGetters }, question_slug) {
	let dependent = rootGetters[question_slug + "/get_option_source_dependent"];
	if (!dependent) {
		get_options_from_server(
			commit,
			question_slug,
			rootGetters[question_slug + "/get_option_source"]
		);
		return;
	}

	let dependent_answer = rootGetters[dependent + "/answer"];
	let filter_key =
		rootGetters[question_slug + "/get_option_source_dependent_filter_key"];
	if (dependent_answer) {
		let option_source = JSON.parse(
			JSON.stringify(rootGetters[question_slug + "/get_option_source"])
		);

		let dependent_filter = {
			operand: filter_key,
			operator: "=",
			argument: dependent_answer
		};
		option_source.filter.push(dependent_filter);

		get_options_from_server(commit, question_slug, option_source);
	}
}

function get_options_from_server(commit, question_slug, option_source) {
	Axios.post("/question/ddl-options", option_source).then(function(response) {
		commit(question_slug + "/set_options", response.data.data, {
			root: true
		});
	});
}
